import { app } from '../../app.module'
app
  // サブカテゴリ情報管理モーダル
  .directive('editSubCategoryModal', () => {
    return {
      restrict: 'A',
      controller: ($scope, $mdDialog, EditSubCategoryService, DialogService) => {
        const beforeSaveInfo = {
          beforeSaveCategory: $scope.categoryName,
          beforeSaveSubCategory: $scope.subCategoryName,
          sortNo: $scope.sortNo,
        }

        // サブカテゴリを編集
        $scope.saveSubCategory = function (
          categoryName: string,
          subCategoryName: string,
          sortNo: number
        ) {
          const saveInfo = {
            saveType: $scope.type,
            categoryName: categoryName,
            subCategoryName: subCategoryName,
            beforeSaveCategory: beforeSaveInfo.beforeSaveCategory,
            beforeSaveSubCategory: beforeSaveInfo.beforeSaveSubCategory,
            sortNo: sortNo,
          }

          EditSubCategoryService.editSubCategory.saveSubCategory(saveInfo).then((result) => {
            // 保存成功時
            if (result.error === false) {
              // モーダルを閉じる
              $mdDialog.hide()
              // カテゴリ情報が変更されたことを親スコープへ通知
              $scope.$emit('changeCategoriesList')
            } else {
              let errorMessage = 'サブカテゴリの保存に失敗しました。'

              if (result.data === 'duplicate') {
                errorMessage = '既に存在するサブカテゴリです。'
              }
              // 保存失敗時、toastを表示する
              DialogService.showToast(errorMessage, 'error-toast')
            }
          })
        }

        // カテゴリが変更された場合の処理
        $scope.$on('changeBrandCategory', (event, categoryInfo) => {
          if (categoryInfo.type !== 'edit-sub-category') {
            return
          }
          $scope.categoryName = categoryInfo.categoryName
        })

        // 入力したサブカテゴリをリセット
        $scope.cancelSave = function () {
          $scope.categoryName = beforeSaveInfo.beforeSaveCategory
          $scope.subCategoryName = beforeSaveInfo.beforeSaveSubCategory
          $scope.sortNo = beforeSaveInfo.sortNo
        }

        // モーダルを閉じる処理
        $scope.close = function () {
          $mdDialog.hide()
        }
      },
    }
  })
